//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('domObjectTypeMenu', {
//        templateUrl: 'views/components/views/domObjectTypeMenu/domObjectTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'domObjectTypeMenuService', 'ttGridFactory', function ($stateParams, stateService, domObjectTypeMenuService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let domObjectTypeKeyno = $stateParams.domobjecttype_keyno;
            
//            vm.model = {
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_domobjecttypemenu_domobjecttypeprop_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'domobjecttypemenu_new',
//                    text: 'domobjecttypemenu_new',
//                    func: () => {
//                        stateService.go('domobjecttypeprop', {
//                            domobjecttype_keyno: vm.model.menu.domobjecttype_keyno,
//                            domobjecttypeprop_keyno: '0'
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await domObjectTypeMenuService.getDomObjectTypeMenu({ domobjecttype_keyno: domObjectTypeKeyno }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3021,
//                    parameters: { domobjecttype_keyno: vm.model.menu.domobjecttype_keyno }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//            	loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
